import React, {useEffect, useState} from 'react';

// kendo react
import {DropDownList} from "@progress/kendo-react-dropdowns";


export const LicenseTypeCell = (props) => {

    const field = props.field;
    const dataValue = props.dataItem[field];
    const [selected, setSelected] = useState(null)

    useEffect(() => {
        let newlySelected = null
        for (const item of dataValue) {
            if (item.selected) {
                newlySelected = item
            }
        }
        setSelected(newlySelected)
    }, [dataValue])

    //bound input events and values to the Grid
    const onChange = (ev) => {
        if (props.onChange) {
            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: ev.syntheticEvent,
                value: ev.target.value,
            });
        }
        setSelected(ev.target.value)
    };

    const disabled = dataValue.length === 1 ? true : props.dataItem['status'] === 'SELECTED' ? props.dataItem.saved_assigned_quantity > 0 : false

    return (
        <td>
            <DropDownList
                style={{
                    marginTop: '0.188rem',
                    marginBottom: '0.188rem',
                }}
                className={'ksm-dropdownlist'}
                data={dataValue}
                textField="text"
                dataItemKey="license_type"
                value={selected}
                onChange={onChange}
                disabled={disabled}
                valid={!props.dataItem['exceedError']}
            />
        </td>
    );
};
